function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { objectAssign, nodeArray, parentWithClass, Event } from 'meteora';
var DuplicatingFields = /*#__PURE__*/function () {
  function DuplicatingFields(form) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, DuplicatingFields);
    this.form = form;
    this.index = 0;
    this.event = new Event('duplicated');
    this.clone = null;
    this.duplicates = [];
    this.settings = objectAssign({
      trigger: '.js-duplicate--trigger',
      container: '.js-duplicate--container'
    }, options);
    this.triggers = nodeArray(this.form.querySelectorAll(this.settings.trigger));
    this.triggers.forEach(function (trigger) {
      return _this.addEvent(trigger);
    });
  }
  _createClass(DuplicatingFields, [{
    key: "addEvent",
    value: function addEvent(trigger) {
      var _this2 = this;
      trigger.addEventListener('change', function () {
        return _this2.duplicate(trigger);
      });
    }
  }, {
    key: "newElements",
    value: function newElements(selector) {
      if (this.clone) {
        return nodeArray(this.clone.querySelectorAll(selector));
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate(trigger) {
      this.index += 1;
      var container = parentWithClass(trigger, this.settings.container.replace('.', ''));
      var nextTrigger = null;
      this.clone = container.cloneNode(true);
      nextTrigger = this.clone.querySelector(this.settings.trigger);
      nextTrigger.checked = false;
      nextTrigger.id = 'duplicate-content-' + this.index;
      nextTrigger.nextElementSibling.setAttribute('for', 'duplicate-content-' + this.index);
      nodeArray(this.clone.querySelectorAll('input[type="CustomField"]')).forEach(function (input) {
        return input.value = '';
      });
      nodeArray(this.clone.querySelectorAll('select')).forEach(function (select) {
        return select.value = '';
      });
      this.addEvent(nextTrigger);
      container.parentNode.appendChild(this.clone);
      this.duplicates.push(this.clone);
      this.form.dispatchEvent(this.event);
    }
  }, {
    key: "removeDuplicates",
    value: function removeDuplicates() {
      this.duplicates.forEach(function (clone) {
        clone.remove();
      });
    }
  }]);
  return DuplicatingFields;
}();
export { DuplicatingFields as default };